module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/4/2-3bbe8f647f0a7ed7eb31956147d7ab80.jpg";